import type { NavigationItem } from "@/config/navigation/types";
import { DotArt } from "./dot-art";

const PHONEBOOK_ROWS = [
  "........................................",
  "........................................",
  "..........######################........",
  "........#########################.......",
  ".......###########################......",
  "......############################......",
  "......####.....................###......",
  "......###......................###......",
  "......###......................###......",
  "......###.........####.........###......",
  "......###.......########.......###......",
  "......###.......########.......###......",
  "......###......####..####......###......",
  "......###......####..####......###......",
  "......###......####..####......###......",
  "......###......##########......###......",
  "......###.......########.......###......",
  "......###......##########......###......",
  "......###.....############.....###......",
  "......###.....####....####.....###......",
  "......###.....###......###.....###......",
  "......###.....###......###.....###......",
  "......###.....###......###.....###......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......############################......",
  "......############################......",
  "......############################......",
  "......############################......",
  "......####.....................###......",
  "......###......................###......",
  "......###......................###......",
  "......####.....................###......",
  "......############################......",
  ".......###########################......",
  "........#########################.......",
  "..........######################........",
  "........................................",
  "........................................",
] as const;

const RAM_ROWS = [
  "........................................",
  "........................................",
  "...................##...................",
  ".................######.................",
  "................########................",
  "..............############..............",
  "............#######..#######............",
  "........##########....##########........",
  "......##########........##########......",
  "......########............########......",
  "......#####..................#####......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......###......................###......",
  "......####....................####......",
  "......####....................####......",
  ".......####..................####.......",
  ".......####..................####.......",
  "........####................####........",
  "........#####..............#####........",
  ".........######..........######.........",
  "..........######........######..........",
  "...........########..########...........",
  ".............##############.............",
  "...............##########...............",
  ".................######.................",
  "...................##...................",
  "........................................",
  "........................................",
] as const;

const FAB_ROWS = [
  "........................................",
  "........................................",
  "........................................",
  "........................................",
  "...................##...................",
  "..................####..................",
  "..................####..................",
  "..................####..................",
  ".................######.................",
  "..............############..............",
  ".....##############################.....",
  "....################################....",
  "....############..####..############....",
  ".....#######......####......#######.....",
  ".......####.......####.......####.......",
  "......#####.......####.......#####......",
  "......######......####......######......",
  "......######......####......######......",
  ".....########.....####.....########.....",
  ".....########.....####.....########.....",
  "....####..###.....####.....###..####....",
  "....####..####....####....####..####....",
  "....###...####....####....####...###....",
  "...####....###....####....###....####...",
  "...####....####...####...####....####...",
  "...####....####...####...####....####...",
  "..#############...####...#############..",
  "...############...####...############...",
  "....#########.....####.....#########....",
  ".......####.......####.......####.......",
  "..................####..................",
  "..................####..................",
  "............################............",
  "...........##################...........",
  "..........####################..........",
  "...........##################...........",
  "........................................",
  "........................................",
  "........................................",
  "........................................",
] as const;

const FIT_ROWS = [
  "........................................",
  "........................................",
  "........................................",
  "........................................",
  "........................................",
  "........................................",
  "........................................",
  ".............##############.............",
  "...........##################...........",
  "..........####################..........",
  "..........####################..........",
  ".........####..............####.........",
  ".....##..####..............####..##.....",
  "....########................########....",
  "....########................########....",
  ".....##############################.....",
  "......############################......",
  ".....##############################.....",
  "....################################....",
  "....####........................####....",
  "....####........................####....",
  "....####....#..............#....####....",
  "....####...###............####..####....",
  "....####..####............####..####....",
  "....####...##..............##...####....",
  "....####........................####....",
  "....####........................####....",
  "....####........................####....",
  ".....##############################.....",
  ".....##############################.....",
  "......############################......",
  ".......####..................####.......",
  ".......####..................####.......",
  ".......###....................###.......",
  "........................................",
  "........................................",
  "........................................",
  "........................................",
  "........................................",
  "........................................",
] as const;

const CASAVI_ROWS = [
  "........................................",
  "........................................",
  "........................................",
  "........................................",
  "............################............",
  "..........####################..........",
  ".........######################.........",
  ".........######################.........",
  ".........###................###.........",
  ".........###................###.........",
  ".........###................######......",
  ".........###................########....",
  ".........###....########....#########...",
  ".........###...##########...#########...",
  ".........###...##########...###...###...",
  ".....#######................###...####..",
  "....########................###...####..",
  "...#########................###...####..",
  "...#########....########....###...####..",
  "..####...###...##########...###...####..",
  "..####...###...##########...###...####..",
  "..####...###....########....###...####..",
  "..####...###................###...####..",
  "..####...###................###...####..",
  "..####...###................###...####..",
  "..####...###.....######.....###...####..",
  "..####...###....########....###...####..",
  "..####...###....########....###...####..",
  "..####...###...####..####...###...####..",
  "..####...###...####..####...###...####..",
  "..####...###...####..####...###...####..",
  "..####...###...####..####...###...####..",
  "...##################################...",
  "...##################################...",
  "....################################....",
  ".....##############################.....",
  "........................................",
  "........................................",
  "........................................",
  "........................................",
] as const;

const ACE_ROWS = [
  "........................................",
  "........................................",
  ".............#............#.............",
  "............###..........###............",
  "............###..........###............",
  "............####........####............",
  "......############################......",
  ".....##############################.....",
  "....################################....",
  "....####........................####....",
  "....####........................####....",
  "....####........................####....",
  "....####.........######.........####....",
  "....####........########........####....",
  "....####.......##########.......####....",
  "....####......#####..#####......####....",
  "....####......####....####......####....",
  "....####......###......###......####....",
  "....####......###......###......####....",
  "....####......###......###......####....",
  "....####......####....####......####....",
  "....####......############......####....",
  "....####.......##########.......####....",
  "....####........########........####....",
  "....####..........####..........####....",
  "....####........................####....",
  "....####........................####....",
  "....####........................####....",
  "....####.....##############.....####....",
  "....####....################....####....",
  "....####...##################...####....",
  "....####...####..........####...####....",
  "....####..####............####..####....",
  "....####..####............####..####....",
  "....################################....",
  ".....##############################.....",
  "......############################......",
  "........########################........",
  "........................................",
  "........................................",
] as const;

const MASTERDATA_ROWS = [
  "........................................",
  "........................................",
  "........................................",
  ".................######.................",
  "..............############..............",
  "............################............",
  "..........########....########..........",
  "........########........########........",
  "......########............########......",
  "....########................########....",
  "...#######....................#######...",
  "...####..........................####...",
  "...####..........................#####..",
  "...######......................######...",
  "....#######..................#######....",
  ".....#########............#########.....",
  "........########........#########.......",
  "..........########....########..........",
  "...##.......################.......##...",
  "...###........############........###...",
  "...####.........########.........####...",
  "...######..........##..........######...",
  "....########................########....",
  ".....#########............#########.....",
  "........########........########........",
  "..........########....########..........",
  "...##.......################.......##...",
  "..####........############........###...",
  "...####.........########.........####...",
  "...#######.........##.........#######...",
  "....########................########....",
  "......########............#########.....",
  "........########........########........",
  "..........########....########..........",
  "............################............",
  "..............############..............",
  ".................######.................",
  "........................................",
  "........................................",
  "........................................",
] as const;

const FIA_ROWS = [
  "........................................",
  "........................................",
  "...................##...................",
  ".................######.................",
  "...............##########...............",
  ".............##############.............",
  "...........########...########..........",
  ".........########.......########........",
  ".......#######............########......",
  ".....#######................#######.....",
  "....################################....",
  "....################################....",
  "....################################....",
  "......############################......",
  "........................................",
  "........................................",
  "........................................",
  ".........###...###....###...###.........",
  ".........###...####..####...###.........",
  ".........###...####..####...###.........",
  ".........###...####..####...###.........",
  ".........###...####..####...###.........",
  ".........###...####..####...###.........",
  ".........###...####..####...###.........",
  ".........###...####..####...###.........",
  ".........###...####..####...###.........",
  ".........###...####..####...###.........",
  ".........###...####..####...###.........",
  ".........###...####..####...###.........",
  ".........###...####..####...###.........",
  ".........###...###....###...###.........",
  "........................................",
  "........................................",
  "........................................",
  ".....##############################.....",
  "....################################....",
  "....################################....",
  ".....##############################.....",
  "........................................",
  "........................................",
] as const;

const MODULE_DOT_ARTS: Record<string, readonly string[]> = {
  phonebook: PHONEBOOK_ROWS,
  ram: RAM_ROWS,
  fab: FAB_ROWS,
  fit: FIT_ROWS,
  casavi: CASAVI_ROWS,
  ace: ACE_ROWS,
  masterdata: MASTERDATA_ROWS,
  fia: FIA_ROWS,
};

interface ModuleTileDecorationProps {
  item: NavigationItem;
}

/**
 * Content-specific dotted asset for a module tile: a plain dot-matrix frame
 * of the module's motif (phone, shield, ...).
 *
 * Rendered at a fixed scale anchored to the top-right corner (never scaled
 * with the card), with a radial fade so it stays consistent and unobtrusive
 * across all card sizes.
 */
export function ModuleTileDecoration({ item }: ModuleTileDecorationProps) {
  const rows = MODULE_DOT_ARTS[item.id];

  if (!rows) {
    return null;
  }

  return (
    <div
      aria-hidden
      className="text-primary absolute top-0 right-0 mask-[radial-gradient(140%_140%_at_100%_0%,black_60%,transparent_100%)] opacity-55 dark:opacity-40"
    >
      <DotArt rows={rows} className="h-50" />
    </div>
  );
}
